import { useState, useEffect, useRef } from "react";
import Header from "../../../components/Header/Header";
import images from "../../../images";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PerformanceChat = ({ isUser: initialIsUser }) => {
  const [message, setMessage] = useState("");
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [chatMessages, setChatMessages] = useState([
    {
      message: "Hi, I need help setting up a mystery shopping campaign.",
      isUser: true,
      timestamp: "02:12 PM",
    },
    {
      message: "Hello Guy",
      isUser: false,
      timestamp: "02:12 PM",
      avatar:
        "https://cdn.builder.io/api/v1/image/assets/aba98c1d4ac746f9b20d08de60428111/b97eed086f763f066509205cf4d5546e9fc9a4b10cd17d47891ce6b9209fca47?placeholderIfAbsent=true",
    },
    {
      message:
        "Sure! I can guide you through the process. What type of business do you have?",
      isUser: false,
      timestamp: "02:12 PM",
      avatar:
        "https://cdn.builder.io/api/v1/image/assets/aba98c1d4ac746f9b20d08de60428111/b97eed086f763f066509205cf4d5546e9fc9a4b10cd17d47891ce6b9209fca47?placeholderIfAbsent=true",
    },
    {
      message:
        "I run a restaurant and want to evaluate customer service quality.",
      isUser: true,
      timestamp: "02:14 PM",
    },
    {
      message:
        "Great! Do you have any specific aspects you'd like mystery shoppers to focus on? For example, staff friendliness, wait time, or cleanliness?",
      isUser: false,
      timestamp: "02:14 PM",
      avatar:
        "https://cdn.builder.io/api/v1/image/assets/aba98c1d4ac746f9b20d08de60428111/a7adc34f1dc3ac0860461d76dc0092910812508e62fb138ee0b8b011d469edf6?placeholderIfAbsent=true",
    },
  ]);

  const messagesEndRef = useRef(null);

  const handleSendMessage = () => {
    if (message.trim() === "") return;

    const newMessage = {
      message: message,
      isUser: true,
      timestamp: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };

    setChatMessages((prevMessages) => [...prevMessages, newMessage]);
    setMessage("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatMessages]);

  return (
    <main className="flex flex-col h-screen mx-auto w-full bg-neutral-50 overflow-hidden">
      <div className="sticky top-0 left-0 w-full  bg-white shadow-md z-50 rounded-bl-xl rounded-br-xl">
        <Header
          title={t("performan.performanceChat.message")}
          onBackClick={() => navigate(-1)}
          backIcon={images.BackIcon}
        />
      </div>
      <div className="h-32"></div> {/* Adjust height to match header */}
      <section className="flex-1 overflow-y-auto px-4 py-4 bg-neutral-50">
        <div className="flex flex-col space-y-3">
          {chatMessages.map((msg, index) => (
            <div
              key={index}
              className={`flex ${msg.isUser ? "justify-end" : "justify-start"}`}
            >
              <div className="flex items-start max-w-[80%]">
                {!msg.isUser && (
                  <div className="flex flex-col items-center mr-2">
                    <div className="border border-solid rounded-full">
                      {" "}
                      <img
                        src={images?.UserChatBotIcon}
                        alt="Avatar"
                        className=" w-6 h-6 p-1"
                      />
                    </div>
                    <span className="text-xs text-gray-500 mt-1">
                      RallyChat
                    </span>
                  </div>
                )}
                <div className="flex flex-col">
                  <div
                    className={`p-3 rounded-xl text-base leading-6 ${
                      msg.isUser
                        ? "bg-yellow-100 text-black"
                        : "bg-gray-200 text-gray-800"
                    }`}
                  >
                    {msg.message}
                  </div>
                  <time
                    className={`text-xs text-gray-500 mt-1 ${
                      msg.isUser ? "self-end" : "self-start"
                    }`}
                  >
                    {msg.isUser ? "You" : ""} {msg.timestamp}
                  </time>
                </div>
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
      </section>
      <div className="h-16"></div>
      <div className="px-4 py-3 bg-white border-t border-gray-200 sticky  bottom-[75px] left-0 right-0">
        <div className="flex items-center space-x-2">
          <input
            type="text"
            placeholder={t("performan.performanceChat.message")}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            className="flex-1 p-3 rounded-xl bg-gray-100 outline-none text-base"
            aria-label="Chat message input"
          />
          <img
            onClick={handleSendMessage}
            src={images.SendChatIcon}
            alt="Voice input"
            className="object-contain shrink-0 self-stretch my-auto aspect-square w-[34px] absolute right-[70px] bottom-[20px]"
          />
          <button
            onClick={handleSendMessage}
            aria-label="Send message"
            className="p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <img src={images.MicroPhoneIcon} alt="Send" className="w-6 h-6" />
          </button>
        </div>
      </div>
    </main>
  );
};

export default PerformanceChat;
